import { jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { useHeadingLevel } from '../../../utils/heading-level-context/HeadingLevelContext.es.js';
import { clamp } from '../../../utils/clamp.es.js';

const root = "_root_w9t8o_1";
const styles = {
	root: root
};

const Heading = ({ children, className, style }) => {
  const { level } = useHeadingLevel();
  const headingLevel = clamp(level, 1, 6);
  const Tag = `h${headingLevel}`;
  return jsx(Tag, { className: clsx(styles.root, className), "data-zds": true, style, children });
};

export { Heading };
//# sourceMappingURL=Heading.es.js.map
